import React, {useMemo} from "react";
import {subduedTextColour} from "../../../../style/styleConsts";
import {calculateVolumeChangesBetween} from "../volumeCalculator";
import {Table, Th} from "../../../elements/Tables";
import SortArrow from "../../../elements/SortArrow";
import Heading from "../table/Heading";
import {SectorsRow} from "../table/SectorsRow";
import {SentimentChart} from "./SentimentChart";
import {VolumeChart} from "./VolumeChart";

const SORT_FUNCTIONS = {
    sector: {sortFn: (a, b) => a.name.localeCompare(b.name), alphabetic: true},
    volume: {sortFn: (a, b) => b.volumeChange - a.volumeChange},
    sentiment: {sortFn: (a, b) => b.sentimentChange - a.sentimentChange},
};

export const SectorsChangeTable = ({sectors: {sortField, sortReversed, timePeriodName}, sectorsActions, today, previousAverage}) => {
    function sortIcon(columnName) {
        if (columnName !== sortField) {
            return "";
        }
        let arrowUp = sortReversed;
        if (SORT_FUNCTIONS[columnName].alphabetic) {
            arrowUp = !arrowUp;
        }
        return arrowUp ? <SortArrow dir="ASC"/> : <SortArrow dir="DESC"/>;
    }

    const { sortedSectors, sortBySector, sortBySentiment, sortByVolume } = useMemo(() => {
        function sortBy(fieldName) {
            sectorsActions.changeSort(fieldName, !sortReversed && fieldName === sortField);
        }

        return {
            sortedSectors: (function() {
                const sortFn = SORT_FUNCTIONS[sortField].sortFn;
                const volumeChanges = calculateVolumeChangesBetween(today, previousAverage);
                let sortedSectors = volumeChanges.sort(sortFn);
                if (sortReversed) {
                    sortedSectors = sortedSectors.reverse();
                }

                return sortedSectors;
            })(),
            sortBySector() {
                sortBy("sector");
            },
            sortBySentiment() {
                sortBy("sentiment");
            },
            sortByVolume() {
                sortBy("volume");
            }
        };
    }, [sortField, sortReversed]);

    return (
        <Table className="t-sectors-change-chart">
            <thead>
            <tr>
                <Th/>
                <Th colSpan={2} style={{textAlign: "center", color: subduedTextColour}}>Today compared to {timePeriodName}</Th>
            </tr>
            <tr>

                <Heading className="t-heading-sector"
                         onClick={sortBySector}
                         sortIcon={sortIcon("sector")}
                         text="Sector"/>

                <Heading className="t-heading-sentiment"
                         onClick={sortBySentiment}
                         sortIcon={sortIcon("sentiment")}
                         text="% Short/Long"/>

                <Heading className="t-heading-volume"
                         onClick={sortByVolume}
                         sortIcon={sortIcon("volume")}
                         text="Share of Open Ideas"/>
            </tr>
            </thead>
            <tbody className="t-sectors-table">
            {
                sortedSectors.map(sector => {
                    return <SectorsRow key={sector.name}
                                       name={sector.name}
                                       sentimentChart={
                                           <SentimentChart timePeriodName={timePeriodName} {...sector}/>
                                       }
                                       volumeChart={
                                           <VolumeChart timePeriodName={timePeriodName} {...sector}/>
                                       }/>;
                })
            }
            </tbody>
        </Table>
    );
};
